import { employeesExport } from 'services/employeesApi'
import { downloadCSV } from 'utils/downloadCSV'
import { jsonToCsv } from './JsonToCsvConverter'

export const onEmployeesCSVExport = async (
  employeesIndices: string,
  entityId: string,
  vertical: string,
  csvFileName: string,
): Promise<void> => {
  try {
    const { employees, headers } = await employeesExport(employeesIndices, entityId, vertical)
    const employeesCSV = jsonToCsv(employees, headers)
    downloadCSV(employeesCSV, csvFileName)
  } catch (error) {
    console.error('Error exporting CSV:', error)
    throw error
  }
}
